import React from "react";

// Dormant AdSense slot. Renders a discreet placeholder until a Publisher ID is set.
// When window.__ADSENSE_PUBLISHER_ID__ is provided later, real ad markup can be enabled.
export default function AdSlot({ slot = "default", className = "" }) {
  const publisherId = typeof window !== "undefined" ? window.__ADSENSE_PUBLISHER_ID__ : null;
  // Render NOTHING until a publisher ID is configured. This guarantees no empty ad
  // boxes appear on any screen (AdSense policy: no ads on screens without content).
  if (!publisherId) return null;
  return <div data-testid={`ad-slot-${slot}`} className={className} data-ad-slot={slot} />;
}
